export const SUBSCRIPTION_TIER_LAUNCH = 'Launch' as const
export const SUBSCRIPTION_TIER_GROW = 'Grow' as const
export const SUBSCRIPTION_TIER_PRO = 'Pro' as const

export const SUBSCRIPTION_TIER_NAMES = [
  SUBSCRIPTION_TIER_LAUNCH,
  SUBSCRIPTION_TIER_GROW,
  SUBSCRIPTION_TIER_PRO
] as const

export type SubscriptionTierName = (typeof SUBSCRIPTION_TIER_NAMES)[number]
